import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Oops'


export default function getPageTitle(pageTitle) {
  if(pageTitle) {
    return pageTitle
  }
  return title
}